/**
 * Computes how much of a PPD factura was collected via complementos
 * de pago and how much was zeroed out via a nota de crédito.
 *
 * @param {object} factura - Raw factura object from the API
 * @returns {{ cobrado: number, cerrado: number }}
 */
export function calcularCobradoYCerrado(factura) {
    const total = parseFloat(factura.total) || 0
    const cobrado = (factura.pagosAplicados || [])
        .reduce((sum, pago) => sum + (parseFloat(pago.monto) || 0), 0)
    const cerrado = Math.max(0, total - cobrado)
    return { cobrado, cerrado }
}
